const dateFormat: Intl.DateTimeFormatOptions = { month: 'short', day: 'numeric', year: 'numeric' };

// "Sep 24, 2026". Empty for missing or unparseable input.
export const formatDate = (iso?: string | null): string => {
  if (!iso) {
    return '';
  }

  const date = new Date(iso);

  return Number.isNaN(date.getTime()) ? '' : date.toLocaleDateString('en-US', dateFormat);
};

// "just now" / "5 min ago" / "3 hrs ago" / "2 days ago", from a past ISO timestamp.
export const formatTimeAgo = (iso: string, now: number = Date.now()): string => {
  const then = new Date(iso).getTime();

  if (Number.isNaN(then)) {
    return '';
  }

  const minutes = Math.max(0, Math.floor((now - then) / 60000));

  if (minutes < 1) {
    return 'just now';
  }

  if (minutes < 60) {
    return `${minutes} min ago`;
  }

  const hours = Math.floor(minutes / 60);

  if (hours < 24) {
    return `${hours} ${hours === 1 ? 'hr' : 'hrs'} ago`;
  }

  const days = Math.floor(hours / 24);

  return `${days} ${days === 1 ? 'day' : 'days'} ago`;
};

export const pluralize = (count: number, singular: string, plural = `${singular}s`): string =>
  `${count} ${count === 1 ? singular : plural}`;
